import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

// Attach JWT token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("efgh_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("efgh_token");
      localStorage.removeItem("efgh_user");
    }
    return Promise.reject(err);
  }
);

export function getUser() {
  try { return JSON.parse(localStorage.getItem("efgh_user") || "null"); } catch { return null; }
}

export function setSession(token, user) {
  localStorage.setItem("efgh_token", token);
  localStorage.setItem("efgh_user", JSON.stringify(user));
}

export function clearSession() {
  localStorage.removeItem("efgh_token");
  localStorage.removeItem("efgh_user");
}

export function getToken() {
  return localStorage.getItem("efgh_token") || "";
}

/**
 * Extract a safe, string error message from an axios error.
 * FastAPI 422 responses have `detail` as a List[Dict] — sonner/React
 * throws if we pass an object to toast.error, so coerce it here.
 */
export function apiError(err, fallback = "Request failed") {
  const d = err?.response?.data?.detail ?? err?.response?.data?.message;
  if (!d) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join("; ");
  try { return JSON.stringify(d); } catch { return fallback; }
}
